import en from './locales/en.json';

// Components
export { default as UiAlert } from './components/UiAlert.vue';
export { default as UiAppHeader } from './components/UiAppHeader.vue';
export { default as UiAppPage } from './components/UiAppPage.vue';
export { default as UiAvatar } from './components/UiAvatar.vue';
export { default as UiBottomSheet } from './components/UiBottomSheet.vue';
export { default as UiButton } from './components/UiButton.vue';
export { default as UiCard } from './components/UiCard.vue';
export { default as UiDialog } from './components/UiDialog.vue';
export { default as UiEmptyState } from './components/UiEmptyState.vue';
export { default as UiIconButton } from './components/UiIconButton.vue';
export { default as UiListRow } from './components/UiListRow.vue';
export { default as UiLoader } from './components/UiLoader.vue';
export { default as UiMenu } from './components/UiMenu.vue';
export { default as UiOptionGroup } from './components/UiOptionGroup.vue';
export { default as UiReaderPill } from './components/UiReaderPill.vue';
export { default as UiScreen } from './components/UiScreen.vue';
export { default as UiSpinner } from './components/UiSpinner.vue';
export { default as UiSwitch } from './components/UiSwitch.vue';
export { default as UiSwitchRow } from './components/UiSwitchRow.vue';
export { default as UiTabBar } from './components/UiTabBar.vue';
export { default as UiTabBarItem } from './components/UiTabBarItem.vue';
export { default as UiTabs } from './components/UiTabs.vue';
export { default as UiTextField } from './components/UiTextField.vue';
export { default as UiToaster } from './components/UiToaster.vue';

// Composables
export { useForm } from './composables/useForm';
export { type ToastColor, type ToastItem, type ToastOptions, useToast } from './composables/useToast';

// Types
export type { UiMenuItem, UiOptionGroupOption, UiTabsItem } from './types';

// Tools
export { tv, type VariantProps } from './tv';

/**
 * This library's own strings (`ui.*`: aria labels and other defaults), one
 * object per locale. The app merges them into its vue-i18n messages; a new
 * language adds `locales/<lang>.json` here and an entry below.
 */
export const uiMessages = {
  en,
};

export type UiMessageSchema = typeof en;
